import React from 'react';

type LegalSectionProps = {
  legalText: string;
};

export default function LegalSection({ legalText }: LegalSectionProps) {
  return (
    <div
      id="legal-section"
      className="w-full bg-rp-daylight pt-16 pb-20 border-b border-rp-primary-redesign"
    >
      <div
        className="text-xs mx-4 d:mx-122 text-rp-navy"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: legalText }}
      />
    </div>
  );
}
